//import './less/flashMsg.less';

class FlashMsg {
    
    buildContainer = () => {
	    let container = document.createElement('div');
        container.className = 'flashMsg';
        return container;
    };
    
    removeFlash = destinationElement => {
        let toRemove = destinationElement.getElementsByClassName('flashMsg');
        for (let elem of toRemove) {
            elem.remove();
        }
    };
    
    removeGlobalFlash = () => {
	    let toRemove = document.getElementsByClassName('flashMsg');
	
	    setTimeout(() => {
		    for (let elem of toRemove) {
			    elem.remove();
		    }
	    }, 5000);
    };
    
    showMsg = (destinationElement, message, flashClass, isFixed = false ) => {
        this.removeFlash(destinationElement);
        
        let container = this.buildContainer();
        container.classList.add(flashClass);
        container.innerText = message;
        isFixed ? container.classList.add('fixed') : null;
        destinationElement.appendChild(container);
        
        setTimeout(() => {
            this.removeFlash(destinationElement);
        }, 5000);
    };
    
    
}

export default FlashMsg;


// WEBPACK FOOTER //
// ../components/UI/flashMsg/flashMsg.js